// No imports on purpose: the Playwright specs import this file through `#src/*.ts` to test the real
// string in a browser, so it has to load outside the app bundler.

// Mobile means a phone: touch as the primary input on a phone-sized screen. Touch keeps desktop
// windows on the web layout at any size; the size cap keeps tablets there too. Phones reach 480px on
// their short side (Galaxy A55, 480x1040), and the cap leaves room for Android's display size
// setting; the smallest tablet, the iPad mini, is 744px. Web layouts adapt with theme.breakpoints.
const TOUCH_PRIMARY = '(pointer: coarse) and (hover: none)'
const PHONE_LANDSCAPE = `${TOUCH_PRIMARY} and (orientation: landscape) and (max-height: 499.95px)`

export const MOBILE_LAYOUT_MEDIA_QUERY = `@media ${TOUCH_PRIMARY} and (max-width: 499.95px), ${PHONE_LANDSCAPE}`
export const MOBILE_LANDSCAPE_MEDIA_QUERY = `@media ${PHONE_LANDSCAPE}`
